/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Tax_SentInputs */

const vi_einvoice_tax_sent = /** @type {(inputs: Einvoice_Tax_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã gửi dữ liệu đến cơ quan thuế`)
};

/**

* @param {Einvoice_Tax_SentInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_tax_sent = /** @type {((inputs?: Einvoice_Tax_SentInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Tax_SentInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_tax_sent(inputs)
});